import React from 'react';
import { handleOnEnterPressed } from 'swag-client-common/utils/ui.utils';
import classnames from 'classnames';
import { LogoUploadProgressBar } from '../../../../../../info/logo-upload-progress-bar';
import classes from '../single-view-design-upload.scss';
export const SingleViewDesignUploadButton = ({
  view,
  inputId,
  isLimitedEdition,
  showProgressBar,
  onUploadClick,
  onUploadByEnter
}) => {
  return /*#__PURE__*/React.createElement("label", {
    onClick: onUploadClick,
    htmlFor: inputId,
    className: classes.actionable,
    tabIndex: 0,
    onKeyDown: e => handleOnEnterPressed(e, onUploadByEnter),
    "aria-label": `Upload ${view.name} design`
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.wrapper, classes.container, {
      [classes.orangeContainer]: isLimitedEdition,
      [classes.disabled]: view.isDisabled
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.row, classes.center)
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.greyUppercaseLabel
  }, "Upload", ' ', /*#__PURE__*/React.createElement("span", {
    className: classnames(classes.pinkLabel, classes.viewDataName, {
      [classes.orangeLabel]: isLimitedEdition
    })
  }, view.name), ' ', "design")), showProgressBar && /*#__PURE__*/React.createElement(LogoUploadProgressBar, null)));
};